
// Validating Negative values 
export const validateNegativeValues = (value) => {
 if (parseFloat(value) < 0) {
  return "Negative values are not allowed";
 }
 if (parseFloat(value) == 0) {
  return "Zero is not allowed";
 }
 return true;
};
// Validating Negative values 
export const validateNegativeValuesonly = (value) => {
 if (parseFloat(value) < 0) {
  return "Negative values are not allowed";
 }

 return true;
};

// validating empty spaces 
export const validateEmptySpaces = (value) => {
 // Check if the value contains only empty spaces
 if (String(value).trim() === "") {
  return "Please enter a value without empty spaces";
 }
 return true;
};

// validating text spaces 
export const validateTextInput = (value) => {
 const regex = /^[a-zA-Z\s]*$/;
 if (String(value).trim() === "") {
  return "Please enter a value without empty spaces";
 }
 if (!regex.test(value)) {
  return 'Only text input is allowed';
 }
 return true; // Validation passed
};


// Date validation current Date 
export const validateDate = (value) => {
 const selectedDate = new Date(value);
 const yesterday = new Date();
 yesterday.setDate(yesterday.getDate() - 1); // Set the date to yesterday

 if (selectedDate < yesterday) {
  return "Date cannot be in the past";
 }

 return true;
};


//validate end Date
export const validateEndDate = (value, startDateValue) => {
 const startDate = new Date(startDateValue);
 const endDate = new Date(value);

 if (endDate < startDate) {
  return "End date cannot be before the start date";
 }

 return true;
};
export const mobileNumberRegex = /^(\+91|0)?[6789]\d{9}$/;

export const singlepincodeRegex = /^[1-9]{1}[0-9]{2}\\s{0, 1}[0-9]{3}$/;

export const pincodeRegex = /^(?!0)[1-9][0-9]{5}(?:,\s*([1-9][0-9]{5}))*$/;

